import { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import { DashboardContent } from '../components/dashboard/DashboardContent';
import axios from 'axios';
import { API_URL } from '@/config/api';

export const DashboardPage = () => {
  const { user } = useAuth();

  const [hubs, setHubs] = useState([]);
  const [selectedHub, setSelectedHub] = useState(null);
  const [boards, setBoards] = useState([]);
  const [whiteboards, setWhiteboards] = useState([]);
  const [sharedWhiteboards, setSharedWhiteboards] = useState([]);
  const [stats, setStats] = useState({
    assigned_to_me: 0,
    completed_this_week: 0,
    due_today: 0,
    overdue: 0
  });
  const [activities, setActivities] = useState([]);
  const [quickAccess, setQuickAccess] = useState([]);
  const [myTasks, setMyTasks] = useState([]);
  const [loading, setLoading] = useState(true);

  // Workspace & Folder selection
  const [selectedWorkspace, setSelectedWorkspace] = useState(null);
  const [selectedFolder, setSelectedFolder] = useState(null);

  useEffect(() => {
    fetchDashboardData();
  }, []);

  useEffect(() => {
    if (selectedHub) {
      fetchBoards(selectedHub.id);
    }
  }, [selectedHub]);

  const fetchDashboardData = async () => {
    try {
      const [hubsRes, statsRes, activityRes, quickRes, tasksRes, whiteboardsRes, sharedRes] = await Promise.all([
        axios.get(`${API_URL}/hubs`),
        axios.get(`${API_URL}/dashboard/stats`),
        axios.get(`${API_URL}/dashboard/activity`),
        axios.get(`${API_URL}/dashboard/quick-access`),
        axios.get(`${API_URL}/tasks/my`),
        axios.get(`${API_URL}/whiteboards`),
        axios.get(`${API_URL}/whiteboards/shared-with-me`).catch(() => ({ data: [] }))
      ]);

      setHubs(hubsRes.data);
      if (hubsRes.data.length > 0) {
        setSelectedHub(hubsRes.data[0]);
      }
      setStats(statsRes.data);
      setActivities(activityRes.data);
      setQuickAccess(quickRes.data);
      setMyTasks(tasksRes.data);
      setWhiteboards(whiteboardsRes.data);
      setSharedWhiteboards(sharedRes.data);
    } catch (error) {
      console.error('Failed to fetch dashboard data:', error);
    } finally {
      setLoading(false);
    }
  };

  const fetchBoards = async (hubId) => {
    try {
      const response = await axios.get(`${API_URL}/boards/${hubId}`);
      setBoards(response.data);
    } catch (error) {
      console.error('Failed to fetch boards:', error);
    }
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-[#F8FAFC] flex items-center justify-center">
        <div className="text-[#64748B]">Loading...</div>
      </div>
    );
  }

  // Filter whiteboards by workspace/folder
  const filteredWhiteboards = whiteboards.filter(wb => {
    if (selectedFolder) {
      return wb.folder_id === selectedFolder;
    }
    if (selectedWorkspace) {
      return wb.workspace_id === selectedWorkspace && !wb.folder_id;
    }
    return true; // Show all if no workspace/folder selected
  });

  return (
    <div className="min-h-screen bg-[#F8FAFC] overflow-x-hidden" data-testid="dashboard-page">
      <div className="flex min-w-0">
        <DashboardContent
          user={user}
          stats={stats}
          activities={activities}
          quickAccess={quickAccess}
          myTasks={myTasks}
          whiteboards={filteredWhiteboards}
          sharedWhiteboards={sharedWhiteboards}
          onRefresh={fetchDashboardData}
          selectedWorkspace={selectedWorkspace}
          selectedFolder={selectedFolder}
        />
      </div>
    </div>
  );
};
